import { connect } from 'react-redux';
import { compose, pure } from 'utils/react';
import { loadList, load, showModal, hideModal } from 'store/modules/events';
import Events from '../components/Events';

export default compose(
  connect(
    ({ events }) => ({
      events: events.items,
      event: events.event,
      modalEventId: events.modal,
      isLoading: events.loading,
    }),
    {
      loadEvent: load,
      loadEvents: loadList.bind(null, true),
      showModal,
      hideModal,
    },
  ),
  pure(),
)(Events);
